import React from 'react';

import Util from '$utilities';
import { Footer, Header } from '$partials/global';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @type {import('$types/components/pages.d.ts').ErrorPage}
 */
const ErrorPage = (props) => {
    const status = Util.try(() => props.err.status) || 500;

    let heading = '';
    let text = '';
    switch(status) {
        case 404:
            heading = props?.data?.errorPageSettings?.heading404 || 'Sorry, we couldn’t find that page';
            text = props?.data?.errorPageSettings?.text404 || 'Unfortunately the page you have requested could not be found.';
            break;
        case 500:
            heading = props?.data?.errorPageSettings?.heading500 || 'Sorry, something went wrong';
            text = props?.data?.errorPageSettings?.text500 || 'Unfortunately the page you have requested could not be found.';
            break;
        default:
            heading = 'Sorry, something went wrong.';
    }

    return (
        <>
            <Header
                {...props?.data?.header}
                articleLandingPageUrl={props?.data?.articleLandingPageUrl}
                pageType='ErrorPage' />
            <main id='main-content'>
                <div className='layout-container layout-site-outer-padding pb-8 md:pb-16'>
                    <div className='col-wrapper-breakout flex flex-wrap rounded-lg bg-surface-panel-white'>
                        <div className='w-full flex flex-col gap-8 col-padding py-16'>
                            {/* Title */}
                            <h1 className='type-style-sans-display'>
                                {heading}
                            </h1>
                            <p className='type-style-sans-h3'>
                                {text}
                            </p>
                        </div>
                    </div>
                </div>
            </main>

            <Footer
                {...props?.data?.footer}
                pageType='ErrorPage' />
        </>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

export default ErrorPage;
